import React, { useContext, useEffect, useRef, useState } from "react";
import { Colorcontext } from "../../../Component/Colorcontext/ColorContext";
import vectorarrow from "../../../Images/vectorarrow.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HttpClient from "../../../utils/HttpClient";
import SubscriptionPlans from "../components/SubscriptionPlans";

const ListBusinessContactForm = ({ formData, updateData, onNext, onBack }) => {
  const colordata = useContext(Colorcontext);
  const location = useLocation();
  const navigate = useNavigate();
  const { choosePlanID, username, password } = location.state || {};
  const [toggleDesignation, setToggleDesignation] = useState(false);
  const [toggleTypeOfBussiness, setToggleTypeOfBussiness] = useState(false);
  const [toggleState, setToggleState] = useState(false);
  const [toggleCountry, setToggleCountry] = useState(false);
  const [designationName, setDesignationName] = useState("");
  const [bussinessName, setBussinessName] = useState("");

  const [selectedPlan, setSelectedPlan] = useState({ _id: "", name: "" });
  const [plans, setPlans] = useState([]);
  const [country, setCountry] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [company, setCompany] = useState([]);
  const [countryState, setCountryState] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    colordata.setcolor(true);
    return () => {
      colordata.setcolor(false);
    };
  }, []);

  useEffect(() => {
    getPlan();
    getCountry();
    getCompany();
    getDesignation();
  }, []);

  useEffect(() => {
    choosedPlan();
  }, [plans, choosePlanID]);

  useEffect(() => {
    updateData({ ...formData, subscriptionId: selectedPlan?._id })
  }, [selectedPlan])

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    getState();
  }, [formData.country]);

  const getState = async () => {
    const res = await HttpClient.requestData("countrywise-state/" + formData.country, "GET", {});
    if (res && res?.status) {
      setCountryState(res?.data?.[0]?.states);
    }
  };

  const getCompany = async () => {
    const response = await HttpClient.requestData("companyType", "GET", "");
    if (response.status) {
      setCompany(response.data);
    } else {
      console.log("Error while fetching company data");
    }
  };

  const getCountry = async () => {
    const res = await HttpClient.requestData("countries", "GET", {});
    if (res && res?.status) {
      setCountry(res?.data);
    }
  };

  const getDesignation = async () => {
    const response = await HttpClient.requestData("designation", "GET", "");
    if (response.status) {
      setDesignation(response.data);
    } else {
      console.log("Error while fetching designation data");
    }
  };

  const getPlan = async () => {
    const res = await HttpClient.requestData("subscription-plans", "GET", "");
    if (res && res.status) {
      setPlans(res?.data.reverse());
    } else {
      console.log("Error from getting subscription:", res);
    }
  };

  const choosedPlan = () => {
    if (plans.length === 0 || !choosePlanID) return;
    const selected = plans.find((item) => item._id === choosePlanID);
    if (selected) {
      setSelectedPlan({ _id: selected._id, name: selected.plan });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    updateData(name, value);
    validateField(name, value);
  };

  const validateField = (fieldName, value) => {
    let error = "";
    switch (fieldName) {
      case "personName":
        if (!value) error = "Name is required";
        break;
      case "companyName":
        if (!value) error = "Company Name is required";
        break;
      case "emailId":
        if (!value) error = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
          error = "Invalid email format";
        break;
      case "address":
        if (!value) error = "Address is required";
        break;
      case "emirate":
        if (!value) error = "Emirate is required";
        break;
      default:
        break;
    }
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: error }));
  };

  const requiredFields = [
    { fieldID: "personName", fieldName: "Full name" },
    { fieldID: "designationID", fieldName: "Designation" },
    { fieldID: "companyTypeID", fieldName: "Type of business" },
    { fieldID: "companyName", fieldName: "Company name is required" },
    { fieldID: "mobileNo", fieldName: "Mobile number" },
    { fieldID: "emailId", fieldName: "Work email" },
    { fieldID: "address", fieldName: "Address" },
    { fieldID: "emirate", fieldName: "State" },
  ];

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    requiredFields.forEach((field) => {
      if (!formData[field.fieldID]) {
        newErrors[field.fieldID] = `${field.fieldName} is required`;
        isValid = false;
      }
    });

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailId)) {
      newErrors.emailId = "Invalid email format";
      isValid = false;
    }

    // if (formData.webAddress) {
    //   const domainRegex = /^(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
    //   if (!domainRegex.test(formData.webAddress)) {
    //   newErrors.webAddress = "Invalid domain format";
    //   isValid = false;
    //   }
    // }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const updatedFormData = {
      ...formData,
      phone_code: formData.countryCodeMobile,
    };

    if (selectedPlan._id === "") {
      const findIndex = plans.findIndex((item, index) => {
        return item.plan === "Basic";
      });
      selectedPlan._id = plans[findIndex]._id;
    }

    if (validateForm()) {
      formData.subscriptionId = selectedPlan._id;
      updateData(updatedFormData);
      onNext();
    } else {
      console.log("Error");
    }
  };

  const divDesignationRef = useRef(null);
  const divTypeOfBusinessRef = useRef(null);
  const divStateRef = useRef(null);
  const divCountryRef = useRef(null);

  const handleClickOutside = (event) => {
    if (divDesignationRef.current && !divDesignationRef.current.contains(event.target)) {
      setToggleDesignation(false)
    }
    if (divTypeOfBusinessRef.current && !divTypeOfBusinessRef.current.contains(event.target)) {
      setToggleTypeOfBussiness(false)
    }
    if (divStateRef.current && !divStateRef.current.contains(event.target)) {
      setToggleState(false)
    }
    if (divCountryRef.current && !divCountryRef.current.contains(event.target)) {
      setToggleCountry(false)
    }
  };

  return (
    <>
      <section className="wizrd-item-section">
        <div className="wizrd-item-container">
          <div className="list-contact-section">
            <div className="list-sub-section">

              <div className="">
                <SubscriptionPlans
                  plans={plans}
                  setSelectedPlan={setSelectedPlan}
                  selectedPlan={selectedPlan}
                />
              </div>

              <div className="listbusinessdivleftbg">
                <p className="conattaindptxtpp">Contact information</p>

                <div className="contatcindofdicfplx">
                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Full name <span>*</span>
                    </p>
                    <input
                      type="text"
                      name="personName"
                      value={formData.personName}
                      onChange={handleInputChange}
                      placeholder="John Doe"
                      className="inpustxocntbusuitxtpp"
                    />
                    {errors.personName && (
                      <span className="error">{errors.personName}</span>
                    )}
                  </div>

                  <div ref={divDesignationRef} className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      {" "}
                      Designation <span> *</span>
                    </p>
                    <div className="dropwdowndivfrmbusinee" onClick={() => setToggleDesignation(!toggleDesignation)}>
                      {formData?.designationID ? (
                        <p
                          style={{
                            color: "#000",
                            fontWeight: "500",
                          }}
                          className="vectoraarowdivomgulmaili"
                        >
                          {designationName}
                        </p>
                      ) : (
                        <p className="vectoraarowdivomgulmaili">
                          ---Choose---
                        </p>
                      )}
                      <div
                        className="vectoraarowdivomg"
                        onClick={() => setToggleDesignation(!toggleDesignation)}
                      >
                        <img
                          src={vectorarrow}
                          style={{
                            cursor: "pointer",
                          }}
                          alt="..."
                        />
                      </div>
                      {toggleDesignation && (
                        <div className="vectoraarowdivomgulmai">
                          <ul className="vectoraarowdivomgulmaiul">
                            {designation.map((item, index) => {
                              return (
                                <li
                                  className="vectoraarowdivomgulmaili"
                                  key={index}
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    updateData({
                                      ...formData,
                                      designationID: item?._id,
                                    });
                                    setDesignationName(item?.designation);
                                    setToggleDesignation(!toggleDesignation);
                                  }}
                                >
                                  {item?.designation}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      )}
                    </div>
                    {errors.designationID && (
                      <span className="error">{errors.designationID}</span>
                    )}
                  </div>
                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Company name <span> *</span>
                    </p>
                    <input
                      type="text"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleInputChange}
                      placeholder="Company name"
                      className="inpustxocntbusuitxtpp"
                    />
                    {errors.companyName && (
                      <span className="error">{errors.companyName}</span>
                    )}
                  </div>
                  <div ref={divTypeOfBusinessRef} className="contatcindofdiinpur"
                    onClick={() =>
                      setToggleTypeOfBussiness(!toggleTypeOfBussiness)
                    }
                  >
                    <p className="contatcindofdiinpurtxtp">
                      {" "}
                      Type of business <span> *</span>
                    </p>
                    <div className="dropwdowndivfrmbusinee">
                      {formData?.companyTypeID ? (
                        <p
                          className="vectoraarowdivomgulmaili"
                          style={{
                            color: "#000",
                            fontWeight: "500",
                          }}
                        >
                          {bussinessName}
                        </p>
                      ) : (
                        <p className="vectoraarowdivomgulmaili">
                          Select type of business
                        </p>
                      )}
                      <div
                        className="vectoraarowdivomg"
                        onClick={() =>
                          setToggleTypeOfBussiness(!toggleTypeOfBussiness)
                        }
                      >
                        <img
                          src={vectorarrow}
                          style={{
                            cursor: "pointer",
                          }}
                          alt="..."
                        />
                      </div>
                      {toggleTypeOfBussiness && (
                        <div className="vectoraarowdivomgulmai">
                          <ul className="vectoraarowdivomgulmaiul">
                            {company.map((item, index) => {
                              return (
                                <li
                                  className="vectoraarowdivomgulmaili"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    updateData({
                                      ...formData,
                                      companyTypeID: item._id,
                                      companyTypeName: item?.type
                                    });
                                    setToggleTypeOfBussiness(
                                      !toggleTypeOfBussiness
                                    );
                                    setBussinessName(item?.type);
                                  }}
                                >
                                  {item.type}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      )}
                    </div>
                    {errors.companyTypeID && (
                      <span className="error">{errors.companyTypeID}</span>
                    )}
                  </div>
                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">Company number</p>
                    <div className="input-wrapper">
                      <select
                        className="_form-control _countrycodebox inpustxocntbusuitxtpp"
                        aria-label="Default select example"
                        name="countryCodePhone"
                        style={{
                          width: "30%",
                          background: "#fff",
                        }}
                        value={formData.countryCodePhone}
                        onChange={handleInputChange}
                      >
                        {country.map((item, i) => (
                          <option key={i} value={item?.phone_code} selected={item?.phone_code === "+971"}>
                            {item?.emoji} {item?.phone_code}
                          </option>
                        ))}
                      </select>
                      <input
                        // type="number"
                        name="telephoneNo"
                        value={formData.telephoneNo}
                        onChange={handleInputChange}
                        placeholder="Company number"
                        className="inpustxocntbusuitxtpp"
                        style={{
                          width: "70%"
                        }}
                      />
                    </div>
                    {errors.telephoneNo && (
                      <span className="error">{errors.telephoneNo}</span>
                    )}
                  </div>
                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Mobile number<span> *</span>
                    </p>
                    <div className="input-wrapper">
                      <select
                        className="_form-control _countrycodebox inpustxocntbusuitxtpp"
                        aria-label="Default select example"
                        name="countryCodeMobile"
                        style={{
                          width: "30%",
                          background: "#fff",
                        }}
                        value={formData.countryCodeMobile || "+971"}
                        onChange={handleInputChange}
                      >
                        {country.map((item, i) => (
                          <option key={i} value={item?.phone_code} selected={item?.phone_code === "+971"}>
                            {item?.emoji} {item?.phone_code}
                          </option>
                        ))}
                      </select>
                      <input
                        name="mobileNo"
                        value={formData.mobileNo}
                        onChange={handleInputChange}
                        placeholder="Mobile number"
                        className="inpustxocntbusuitxtpp"
                        style={{
                          width: "70%"
                        }}
                      />
                    </div>
                    {errors.mobileNo && (
                      <span className="error">{errors.mobileNo}</span>
                    )}
                  </div>
                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Work email <span> *</span>
                    </p>
                    <input
                      type="text"
                      name="emailId"
                      value={formData.emailId}
                      onChange={handleInputChange}
                      placeholder="info@companyname.com"
                      className="inpustxocntbusuitxtpp"
                    />
                    {errors.emailId && (
                      <span className="error">{errors.emailId}</span>
                    )}
                  </div>
                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Web address <span>* </span>
                    </p>
                    <input
                      type="text"
                      name="webAddress"
                      value={formData.webAddress}
                      onChange={handleInputChange}
                      placeholder="www.webname.com"
                      className="inpustxocntbusuitxtpp"
                    />
                    {errors.webAddress && (
                      <span className="error">{errors.webAddress}</span>
                    )}
                  </div>
                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      City/Town/Area <span>* </span>
                    </p>
                    <input
                      type="text"
                      name="location"
                      value={formData.location}
                      onChange={handleInputChange}
                      placeholder="Healthcare city"
                      className="inpustxocntbusuitxtpp"
                    />
                  </div>
                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Address <span> *</span>
                    </p>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      placeholder="#129 Golden tower"
                      className="inpustxocntbusuitxtpp"
                    />
                    {errors.address && (
                      <span className="error">{errors.address}</span>
                    )}
                  </div>

                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      Country <span> *</span>
                    </p>
                    <select className="neooSelect"
                      name="country"
                      value={formData.country}
                      onChange={handleInputChange}
                    >
                      <option value="" disabled>Choose...</option>
                      {
                        country
                          .map((item, key) => {
                            return (
                              <><option value={item?._id}>{item?.name}</option></>
                            )
                          })
                      }
                    </select>
                  </div>

                  <div className="contatcindofdiinpur">
                    <p className="contatcindofdiinpurtxtp">
                      State <span> *</span>
                    </p>
                    <select className="neooSelect"
                      name="emirate"
                      value={formData.emirate}
                      onChange={handleInputChange}
                    >
                      <option value="">Choose...</option>
                      {
                        countryState?.map((item) => {
                          return (
                            <><option value={item.name}>{item.name}</option></>
                          )
                        })
                      }
                    </select>
                    {errors.emirate && (
                      <span className="error">{errors.emirate}</span>
                    )}
                  </div>


                  {/* <div ref={divStateRef} className="contatcindofdiinpur" onClick={() => setToggleState(!toggleState)}>
                    <p className="contatcindofdiinpurtxtp">
                      {" "}
                      State <span> *</span>
                    </p>
                    <div className="dropwdowndivfrmbusinee">
                      {formData?.emirate ? (
                        <p
                          className="vectoraarowdivomgulmaili"
                          style={{
                            color: "#000",
                            fontWeight: "500",
                          }}
                        >
                          {formData?.emirate}
                        </p>
                      ) : (
                        <p className="vectoraarowdivomgulmaili">State*</p>
                      )}
                      <div
                        className="vectoraarowdivomg"
                        onClick={(e) => {
                          getState()
                          setToggleState(!toggleState)
                        }}
                      >
                        <img onClick={getState} src={vectorarrow} alt="..." />
                      </div>
                      {toggleState && (
                        <div className="vectoraarowdivomgulmai">
                          <ul className="vectoraarowdivomgulmaiul">
                            {countryState.map((item, index) => {
                              return (
                                <li
                                  onClick={() => {
                                    setFormData({
                                      ...formData,
                                      emirate: item.name,
                                    });
                                    setToggleState(!toggleState);
                                  }}
                                  className="vectoraarowdivomgulmaili"
                                >
                                  {item.name}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      )}
                    </div>
                    {errors.emirate && (
                      <span className="error">{errors.emirate}</span>
                    )}
                  </div> */}

                  {/* <div ref={divCountryRef} className="contatcindofdiinpur" onClick={() => setToggleCountry(!toggleCountry)}>
                    <p className="contatcindofdiinpurtxtp">
                      Country <span> *</span>
                    </p>
                    <div className="dropwdowndivfrmbusinee">
                      <p
                        className="vectoraarowdivomgulmaili"
                        style={{
                          color: "#000",
                          fontWeight: "500",
                        }}
                      >
                        United Arab Emirate
                      </p>
                      <div
                        className="vectoraarowdivomg"
                        onClick={() => setToggleCountry(!toggleCountry)}
                      >
                        <img src={vectorarrow} alt="..." />
                      </div>
                      {toggleCountry && (
                        <div className="vectoraarowdivomgulmai">
                          <ul className="vectoraarowdivomgulmaiul">
                            <li className="vectoraarowdivomgulmaili">
                              United Arab Emirate
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </div> */}

                  {/* <div className="contatcindofdiinpurnewalasda">
                    <p className="contatcindofdiinpurtxtp">
                      Location map <span> </span>
                    </p>
                    <input
                      type="text"
                      placeholder="United arab emirate"
                      className="inpustxocntbusuitxtpp"
                    />
                  </div> */}
                </div>

                <div className="btnnexttdivbtndivmain">
                  {/* <button className="btn btn-secondary mr-2" onClick={onBack}>
                    Back
                  </button> */}
                  <Link
                    onClick={handleSubmit}
                    className="btnnexttdivbtn"
                  >
                    Next
                  </Link>

                </div>
              </div>
            </div>
            <div className="listbusinessdivrightt"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ListBusinessContactForm;
